import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const deleteRequest = (userId, eventGuestId) =>
  axios.delete(Routes.event_guest_user_path(userId, { format: 'json' }), {
    params: { event_guest_id: eventGuestId },
  });
